module.exports = __webpack_public_path__ + "static/media/amex_brand.a742088a.png";